import { List, Text } from '@chakra-ui/react'
import React from 'react'
import SoundIcon from '~/assets/icons-light-theme/audio-player/icon-audio-speaker-dark-900.svg'
import PlayIcon from '~/assets/icons-light-theme/icon-play-dark900.svg'
import iconWarningCautionRed from '~/assets/icons-light-theme/icon-warning-caution-red.svg'
import { useSettingsState } from '~/atoms/SettingsState'
import { Alert } from '~/components/core'
import { useNotifications } from '~/hooks/useNotifications'
import { textStyleKeys } from '~/themes/textStyles'

import { SettingLinkAction, SettingToggle } from './SettingItems'
import {
  DefaultSettingsWrapper,
  HelpLink,
  HelpListItem,
  SubheadingSection,
} from './Shared'

export const NotificationSettings = () => {
  const {
    settings: {
      notifications: { hasNewTextSound },
    },
    setHasNewTextSound,
  } = useSettingsState()

  const { hasGranted, sendSampleNotification } = useNotifications()

  return (
    <DefaultSettingsWrapper>
      {!hasGranted ? (
        <Alert icon={iconWarningCautionRed}>
          You've blocked notifications. You'll need to go into your browser
          settings to switch this back on.
        </Alert>
      ) : null}
      <SubheadingSection>
        <Text textStyle={textStyleKeys.Body2_Bold}>Desktop Notifications</Text>
        <SettingToggle
          icon={SoundIcon}
          label="Play Sound for New Texts"
          onClick={() => setHasNewTextSound(!hasNewTextSound)}
          isChecked={hasNewTextSound}
          disabled={!hasGranted}
        />
        {hasGranted && (
          <SettingLinkAction
            icon={PlayIcon}
            label="Test notification"
            onClick={sendSampleNotification}
          />
        )}
        <Text textStyle={textStyleKeys.Body3}>
          The volume of the notification is controlled by your computer
        </Text>
        <Text textStyle={textStyleKeys.Body2_Bold}>Help</Text>
        <List>
          <HelpListItem>
            <Text textStyle={textStyleKeys.Body3}>
              <HelpLink
                href="https://support.mangovoice.com/how-do-i-turn-on-off-notifications-on-the-web-app-windows-instructions/"
                target="_blank"
                rel="noopener noreferrer"
              >
                How do I turn on / off the notifications
              </HelpLink>{' '}
              on Google Chrome?
            </Text>
          </HelpListItem>
        </List>
      </SubheadingSection>
    </DefaultSettingsWrapper>
  )
}
